import React, { useEffect } from "react";
import { Button, Col,  Table, InputGroup, FormControl} from "react-bootstrap";
import {v4 as uuidv4} from "uuid";
import { useAuth } from "../providers/authprovider";

export function BuildingFilesForm(props){
    //create grid layout for files, select them from api, add new files, delete files

    const {buildings: {getBuildingImagesList, uploadBuildingImage, deleteBuildingImage, downloadEventImage: downloadBuildingImage}} = useAuth();
    const [files, setFiles] = React.useState([]);
    const [selectedFile, setSelectedFile] = React.useState(null);  // State to store the selected file

    function selectBuildingFilesList(){
        getBuildingImagesList(props.buildingId, (response) => {
            console.log("buildings attachments", response);
            setFiles(response.content);
        });
    }
    
    useEffect(() => {
        console.log("building files form", props.buildingId);
        //get files from api
        selectBuildingFilesList();
    }, []);

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);  // Store the selected file in state
    };

    const handleUpload = async () => {
        if (!selectedFile) {
            console.log("No file selected");
            return;
        }
    
        const formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('buildingId', props.buildingId);
    
        try {
            const response = await uploadBuildingImage(formData);
    
            if (response.success) {
                console.log("File uploaded successfully", response.content);
                selectBuildingFilesList();
            } else {
                console.error("Error uploading file:", response.error);
            }
        } catch (error) {
            console.error("Unexpected error:", error);
        }
    };

    const handleDeleteFile = (file) => {

        if(window.confirm("Czy na pewno chcesz usunąć ten plik?") == false) return
        //delete file from api
        deleteBuildingImage(file.id, (response) => {
            if (response.success) {
                console.log("File deleted successfully", response.content);
                selectBuildingFilesList();
            } else {
                console.error("Error uploading file:", response.error);
                alert("Nie udało się usunąć pliku");
            }
        });    
    
    }

    const handleDownloadBuildingImage = (file) => {
        
        downloadBuildingImage(file.id, ({success, error, content})=>{
            if(!success)
                return;

            const url = window.URL.createObjectURL(new Blob([content]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', file.filename);  // Ensure the file is saved with its original name
            
            // Append the link to the document body
            document.body.appendChild(link);
            
            // Trigger a click event on the link to start the download
            link.click();
            
            // Clean up the DOM by removing the link element and revoking the object URL
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        })
    }


    return (
        <Col md={12} lg={6} >
                    <Table striped bordered hover size="sm" className="mt-2">
                        <thead>
                            <tr>
                                <th>Nazwa</th>
                                <th>Rozmiar</th>
                                <th>Podgląd</th>
                                <th>Usuń</th>
                            </tr>
                        </thead>
                        <tbody>
                            {files.map((file) => {
                                return (
                                    <tr key={uuidv4()}>
                                        <td>{file.filename}</td>
                                        <td>{formatFileSize(file.size)}</td>
                                        <td>
                                            <Button variant="info" onClick={()=>{handleDownloadBuildingImage(file)}}>Podgląd</Button>
                                        </td>
                                        <td>
                                        <Button variant="danger" onClick={()=>{handleDeleteFile(file)}}>Usuń</Button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                <InputGroup className="w-50">
                    <FormControl
                            type={"file"}
                            accept={"image/jpeg,image/gif,image/png, application/pdf"}
                            name={"signature"}
                            placeholder={"załącznik w formacie .pjg, .gif, .png, .pdf"}
                            onChange={handleFileChange}
                    />
                    <Button variant="primary" type="button" disabled={selectedFile == null} onClick={handleUpload}>
                    Wyślij
                    </Button>
                </InputGroup >
                
            </Col>
    )
}

function formatFileSize(bytes) {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Bytes';
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
}